import { Box, Stack, Typography, Button, Chip } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { useSelector } from 'react-redux';

export default function WizardTopBar({ onOpen }) {
  const merchant = useSelector((s) => s.pricingWizard.merchant);
  const signup = useSelector((s) => s.pricingWizard.signup);

  const brand = merchant?.brand || signup.brand || signup.business_name || 'New merchant';

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        bgcolor: 'rgba(255,255,255,0.92)',
        backdropFilter: 'saturate(180%) blur(10px)',
        borderBottom: 1,
        borderColor: 'divider',
        px: 2.5,
        py: 1.25,
        display: 'flex',
        alignItems: 'center',
        gap: 1.75,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 12.5 }}>
          Merchant Config <Box component="span" sx={{ color: 'grey.400', mx: 0.5 }}>›</Box>
          <Box component="b" sx={{ color: 'text.primary' }}>Pricing Setup Wizard</Box>
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ ml: 'auto' }}>
        <Chip
          size="small"
          label={brand}
          sx={{
            bgcolor: 'primary.lighter',
            color: 'primary.dark',
            fontWeight: 600,
            fontSize: 12,
            border: 1,
            borderColor: 'primary.light',
          }}
        />
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          startIcon={<MenuBookOutlinedIcon sx={{ fontSize: 16 }} />}
          onClick={() => onOpen('help')}
          sx={{ fontSize: 12.5 }}
        >
          Help
        </Button>
      </Stack>
    </Box>
  );
}
